if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.onSelectChange = () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (!this.currentVariant) {
            this.updateButton(true);
            this.isUpdating = false;
            return;
          }
          let changedInput;
          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  changedInput = element;
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                      changedInput = radio;
                    }
                  });
                  break;
              }
            });
            this.updateButton(true);
            try {
              changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
            } finally {
              this.isUpdating = false;
            }
            return;
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, FoxTheme.variantStrings.unavailable || FoxTheme.variantStrings.soldOut);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        };
        this.select?.addEventListener('change', this.onSelectChange);
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onSelectChange);
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
        this.mediaQuery?.removeEventListener('change', this.onDeviceChange);
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.onDeviceChange = this.checkDevice.bind(this);
        this.mediaQuery.addEventListener('change', this.onDeviceChange);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        if (this.mainProductInfo?.selectionState) disable = true;
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const wrapper = this.querySelector('.f-price');
        if (!wrapper) return;
        const variant = this.currentVariant;
        wrapper.classList.toggle('f-price--unavailable', !variant);
        if (!variant) return;

        const onSale = Number(variant.compare_at_price) > Number(variant.price);
        const money = amount => FoxTheme.Currency.formatMoney(amount, FoxTheme.settings.moneyFormat);
        wrapper.classList.toggle('f-price--on-sale', onSale);
        wrapper.classList.toggle('f-price--sold-out', !variant.available);
        wrapper.classList.remove('f-price--no-compare');
        const updateText = (selector, value) => {
          const node = wrapper.querySelector(selector);
          if (node) node.textContent = value;
        };
        updateText('[data-regular-price]', money(variant.price));
        updateText('.f-price-item--sale', money(variant.price));
        updateText('[data-compare-price]', onSale ? money(variant.compare_at_price) : '');

        const unitWrapper = wrapper.querySelector('.f-price__unit-wrapper');
        const measurement = variant.unit_price_measurement;
        unitWrapper?.classList.toggle('hidden', !measurement);
        updateText('[data-unit-price]', measurement ? money(variant.unit_price) : '');
        updateText('[data-unit-price-base-unit]', measurement
          ? (measurement.reference_value === 1 ? '' : measurement.reference_value) + measurement.reference_unit
          : '');

        const badge = wrapper.querySelector('.f-price__badge-sale');
        if (badge && ['percentage', 'fixed_amount'].includes(badge.dataset.type)) {
          const amount = onSale ? (badge.dataset.type === 'percentage'
            ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'
            : money(variant.compare_at_price - variant.price)) : '';
          const label = badge.querySelector('.f-badge');
          if (label) label.textContent = badge.dataset.savingsTemplate.replace('[amount]', amount);
        }
      }

      syncWithMainProductForm() {
        this.unsubscribeVariantChange = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo?.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          if (variantInput) variantInput.value = variant?.id ?? '';
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, FoxTheme.variantStrings.unavailable || FoxTheme.variantStrings.soldOut);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
